import React, { Component } from "react";
import Form from "../components/form/form";
import Menu from "../components/menu";
import ReactGA from "react-ga4";

const LOCALES = {
  titre: {
    label: {
      fr: "Commerce international québécois et canadien par industrie (SCIAN)",
      en: "Québec and canadian international trade by industry (NAICS)",
    },
  },
};

class Scian extends Component {
  constructor(props) {
    super(props);
    this.page = "scian";
  }

  componentDidMount() {
    //Google analytics 4
    ReactGA.event("page_view", {
      page_title: LOCALES.titre.label[this.props.lang],
    });
  }

  render() {
    return (
      <div className="page page-scian">
        <Menu lang={this.props.lang} activePage={this.page} />
        <div id="contenu_centre">
          <h1>{LOCALES.titre.label[this.props.lang]}</h1>
          <Form
            lang={this.props.lang}
            page={this.page}
            showModal={this.props.showModal}
          />
        </div>
      </div>
    );
  }
}

export default Scian;
